import { render } from "./chat_list.vue?vue&type=template&id=5d61dffd"
import script from "./chat_list.js?vue&type=script&lang=js"
export * from "./chat_list.js?vue&type=script&lang=js"

import "./chat_list.vue?vue&type=style&index=0&id=5d61dffd&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__